export const backendUrl = import.meta.env.VITE_BACKEND_URL;
